export default [
  { id: "#path5419", d: "M644.5,625.4l-37-51.8l42.6,30.2L644.5,625.4z" },
  { id: "#path4232", d: "M617,569.6l-9.6,3.8l42.6,30.2L617,569.6z" },
  { id: "#path4236", d: "M617,569.6l-9.6,3.8l-1.3-38.4L617,569.6z" },
  { id: "#path4240", d: "M576.4,542.4l31,31l-1.3-38.4L576.4,542.4z" },
  { id: "#path4244", d: "M576.4,542.4l12.1-19l17.5,11.5L576.4,542.4z" },
  { id: "#path4248", d: "M576.4,542.4l12.1-19l-24.6-7.9L576.4,542.4z" },
  { id: "#path4252", d: "M572.4,506.6l16.2,17l-24.6-7.9L572.4,506.6z" },
  { id: "#path4628", d: "M572.4,506.6l-6.7-9.4l-1.8,18.5L572.4,506.6z" },
  { id: "#path4632", d: "M547.5,476.3l18.1,20.8l-1.8,18.5L547.5,476.3z" },
  { id: "#path4634", d: "M576.4,542.4l-76.7-30.6l64.2,3.7L576.4,542.4z" },
  { id: "#path4636", d: "M547.7,475.4l-48.1,36.5l64.2,3.7L547.7,475.4z" },
  { id: "#path4644", d: "M547.7,475.4l-48.1,36.5l17.3-49.8L547.7,475.4z" },
  { id: "#path4646", d: "M436.3,476.9l63.3,34.9l17.3-49.8L436.3,476.9z" },
  { id: "#path4648", d: "M436.3,476.9l66-48.4l14.5,33.6L436.3,476.9z" },
  { id: "#path4656", d: "M436.3,476.9l66-48.4L421.4,452L436.3,476.9z" },
  { id: "#path4658", d: "M454.3,381.5l48.1,47.1L421.4,452L454.3,381.5z" },
  { id: "#path4660", d: "M454.3,381.5l48.1,47.1l-11.9-37.8L454.3,381.5z" },
  { id: "#path4662", d: "M518.6,432.6l-16.2-4.2l-11.9-37.8L518.6,432.6z" },
  { id: "#path4672", d: "M454.3,381.5l-66.7,0.5l33.9,70L454.3,381.5z" },
  { id: "#path4674", d: "M372,455.2l15.6-73.3l33.9,70L372,455.2z" },
  { id: "#path4676", d: "M372,455.2l-7.8,31.5l57.2-34.7L372,455.2z" },
  { id: "#path4678", d: "M435.5,475.4l-71.3,11.3l57.2-34.7L435.5,475.4z" },
  { id: "#path4688", d: "M372,455.2l15.6-73.3l-27.4-12.3L372,455.2z" },
  { id: "#path4690", d: "M372,455.2l-56.5-5l44.8-80.5L372,455.2z" },
  { id: "#path4692", d: "M372,455.2l-56.5-5l47.8,37.4L372,455.2z" },
  { id: "#path4694", d: "M303.7,472.3l11.7-22l47.8,37.4L303.7,472.3z" },
  { id: "#path4704", d: "M308.3,370.6l7,79.6l44.8-80.5L308.3,370.6z" },
  { id: "#path4706", d: "M308.3,370.6l7,79.6l-52.2-22.3L308.3,370.6z" },
  { id: "#path4708", d: "M302.9,472.3l12.5-22l-52.3-22.4L302.9,472.3z" },
  { id: "#path4729", d: "M302.9,472.3l-52.7-13.4l12.9-30.8L302.9,472.3z" },
  { id: "#path4731", d: "M308.3,370.6l-74.5-42.2l29.3,99.5L308.3,370.6z" },
  { id: "#path4733", d: "M197.4,402.5l36.5-73.9l29.3,99.5L197.4,402.5z" },
  { id: "#path4735", d: "M197.4,402.5l-3,23.7l68.8,1.7L197.4,402.5z" },
  { id: "#path4743", d: "M250.2,459l-55.8-33l68.8,1.7L250.2,459z" },
  { id: "#path4747", d: "M250.2,459l-55.8-33l1.3,18.8L250.2,459z" },
  { id: "#path4749", d: "M250.2,459l-36.4,18.3L195.7,445L250.2,459z" },
  { id: "#path4755", d: "M190.5,457.6l23.3,19.9L195.7,445L190.5,457.6z" },
  { id: "#path4757", d: "M171,443.6l23.3-17.4l1.3,18.8L171,443.6z" },
  { id: "#path4776", d: "M171,443.6l23.3-17.4l-46,6.5L171,443.6z" },
  { id: "#path4778", d: "M171,443.6l-13.2,17.5l-9.6-28.5L171,443.6z" },
  { id: "#path4780", d: "M190.5,457.6l23.3,19.9l-35.2,3.2L190.5,457.6z" },
  { id: "#path4799", d: "M171,443.6l-13.2,17.5l13.7-1.3L171,443.6z" },
  { id: "#path4801", d: "M197.4,402.5l36.5-73.9l-59.2,28.9L197.4,402.5z" },
  { id: "#path4818", d: "M177.2,314l56.7,14.5l-59.2,28.9L177.2,314z" },
  { id: "#path4820", d: "M162.6,479.3l-4.6-18.2l13.7-1.3L162.6,479.3z" },
  { id: "#path4822", d: "M162.6,479.3l14,1.2l-4.9-20.7L162.6,479.3z" },
  { id: "#path4824", d: "M190.5,457.6l-14,22.9l-4.9-20.7L190.5,457.6z" },
  { id: "#path4858", d: "M162.6,479.3l14,1.2l5.1,25L162.6,479.3z" },
  { id: "#path4860", d: "M162.6,479.3l-4.6-18.2L125.1,480L162.6,479.3z" },
  { id: "#path4862", d: "M162.6,479.3l13.2,41.7l5.9-15.3L162.6,479.3z" },
  { id: "#path4864", d: "M221.5,521.9l-45.7-1.1l5.9-15.3L221.5,521.9z" },
  { id: "#path4866", d: "M221.5,521.9l-45.7-1.1l49.4,18.1L221.5,521.9z" },
  { id: "#path4878", d: "M162.6,479.3l-31.8,20.3l-5.7-19.6L162.6,479.3z" },
  { id: "#path4880", d: "M94.7,500.1l36.1-0.7l-5.7-19.6L94.7,500.1z" },
  { id: "#path4961", d: "M94.7,500.1l36.1-0.7l-30.1,14.9L94.7,500.1z" },
  { id: "#path5128", d: "M94.7,500.1l5.5,14.8l-33.7,22.4L94.7,500.1z" },
  { id: "#path5130", d: "M94.7,500.1L50,525.4l16.5,11.9L94.7,500.1z" },
  { id: "#path5136", d: "M177.2,314l-27.2-1.7l24.5,44.9L177.2,314z" },
  { id: "#path5138", d: "M177.2,314l-26.4-0.7l-8.4-14.5L177.2,314z" },
  { id: "#path5140", d: "M177.2,314l56.7,14.5l-30.4-53.4L177.2,314z" },
  { id: "#path5142", d: "M177.2,314l-38.5-44.3l64.7,5.4L177.2,314z" },
  { id: "#path5144", d: "M177.2,314l-38.4-44.3l3.4,29.5L177.2,314z" },
  { id: "#path5166", d: "M177.2,314l-38.4-44.3l3.4,29.5L177.2,314z" },
  { id: "#path5168", d: "M117.5,316.3l33.3-3l-8.4-14.5L117.5,316.3z" },
  { id: "#path5170", d: "M117.5,316.3l-14-8.4l38.9-9.1L117.5,316.3z" },
  { id: "#path5172", d: "M139.2,268.9l-35.6,38.9l38.9-9.1L139.2,268.9z" },
  { id: "#path5174", d: "M161.8,244.9l-23.1,24.6l64.7,5.4L161.8,244.9z" },
  { id: "#path5176", d: "M161.8,244.9l37.4,2.2l4.2,27.9L161.8,244.9z" },
  { id: "#path5186", d: "M161.8,244.9l37.4,2.2l-10.5-25.6L161.8,244.9z" },
  { id: "#path5188", d: "M161.8,244.9l10.3-33.5l16.6,10L161.8,244.9z" },
  { id: "#path5190", d: "M161.8,244.9l10.3-33.5l-24.5,17L161.8,244.9z" },
  { id: "#path5200", d: "M152.4,208.4l19.6,3l-24.5,17L152.4,208.4z" },
  { id: "#path5202", d: "M152.4,208.4l-15.3,3l10.4,17L152.4,208.4z" },
  { id: "#path5204", d: "M152.4,208.4l-15.3,3L122,171.9L152.4,208.4z" },
  { id: "#path5206", d: "M95.1,205.4l42.2,6.1l10.4,17L95.1,205.4z" },
  { id: "#path5208", d: "M95.1,205.4l42.2,6.1l-35.5-15.6L95.1,205.4z" },
  { id: "#path5258", d: "M95.1,205.4l-29.3-37.3l36,27.8L95.1,205.4z" },
  { id: "#path5260", d: "M222.3,213.6l-23.1,33.6l-10.5-25.6L222.3,213.6z" },
  { id: "#path5262", d: "M217.7,194.1l-45.6,17.4l16.6,10L217.7,194.1z" },
  { id: "#path5270", d: "M217.9,194.5l-45.9,17l12-43.9L217.9,194.5z" },
  { id: "#path5272", d: "M217.9,194.5l-8.3-25.4l-25.7-1.4L217.9,194.5z" },
  { id: "#path5286", d: "M217.9,194.5l-8.3-25.4l14,4.3L217.9,194.5z" },
  { id: "#path5288", d: "M217.9,194.5l-8.3-25.4l-25.7-1.4L217.9,194.5z" },
  { id: "#path5296", d: "M217.9,194.5l19.6-17.7l-14-3.3L217.9,194.5z" },
  { id: "#path5298", d: "M265.4,144.1l-27.7,32.8l-14.1-3.4L265.4,144.1z" },
  { id: "#path5306", d: "M217.9,194.5l-8.3-25.4l-25.7-1.4L217.9,194.5z" },
  { id: "#path5310", d: "M265.4,144.1l-10.3-7.1l-31.5,36.5L265.4,144.1z" },
  { id: "#path5316", d: "M265.4,144.1l-10.3-7.1l14-49.6L265.4,144.1z" },
  { id: "#path5324", d: "M183.5,166.9l26.2,2.1l-14.4-13L183.5,166.9z" },
  { id: "#path5341", d: "M216.1,158.1l-6.3,11.1l-14.4-13L216.1,158.1z" },
  { id: "#path5343", d: "M183.5,166.9l-15.7-18.1l27.5,7.1L183.5,166.9z" },
  { id: "#path5345", d: "M133,109.2l34.8,39.8l27.5,7.1L133,109.2z" },
  { id: "#path5357", d: "M216.1,158.1l-5.1-19.6L195.4,156L216.1,158.1z" },
  { id: "#path5359", d: "M216.1,158.1l-5.1-19.6l13.6-6.5L216.1,158.1z" },
  { id: "#path5361", d: "M202.5,74.6l8.4,63.8l13.6-6.5L202.5,74.6z" }
];
